import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"

import Button from "shared/components/Button/Button"
import ThemeConsumer from "shared/components/ThemeConsumer"

import {
  INVOICE_CANCEL_MODAL_BUTTON,
  INVOICE_CONFIRM_MODAL_BUTTON
} from "shared/constants/idsElements"
const ModalFooter = ({
  theme,
  widthButton,
  secondaryWidthButton,
  onCancel,
  onConfirm,
  cancelButtonText,
  confirmButtonText,
  disabled,
  removeButton = false,
  cancelButtonProps,
  primaryButtonStyle,
  positionFooter = "end",
  ...props
}) => {
  const containerClasses = classnames(
    theme.containerButton,
    theme[`position_${positionFooter}`]
  )

  return (
    <footer className={containerClasses}>
      {!removeButton && (
        <Button
          buttonStyle="secondary"
          width={secondaryWidthButton}
          onClick={onCancel}
          id={INVOICE_CANCEL_MODAL_BUTTON}
          type="button"
          {...cancelButtonProps}
        >
          {cancelButtonText}
        </Button>
      )}
      <Button
        {...props}
        onClick={onConfirm}
        buttonStyle={primaryButtonStyle || "primary"}
        width={widthButton}
        id={INVOICE_CONFIRM_MODAL_BUTTON}
        disabled={disabled}
        type="button"
      >
        {confirmButtonText}
      </Button>
    </footer>
  )
}
ModalFooter.propTypes = {
  theme: PropTypes.shape({
    containerButton: PropTypes.string,
    centeredButton: PropTypes.string
  }),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  widthButton: PropTypes.string,
  disabled: PropTypes.bool,
  removeButton: PropTypes.bool,
  cancelButtonProps: PropTypes.object,
  positionFooter: PropTypes.string,
  secondaryWidthButton: PropTypes.string,
  primaryButtonStyle: PropTypes.string
}
ModalFooter.defaultProps = {
  widthButton: "small",
  secondaryWidthButton: "small",
  cancelButtonText: "Voltar",
  confirmButtonText: "Continuar"
}
export default ThemeConsumer("UIModernModal")(ModalFooter)



// WEBPACK FOOTER //
// ./src/shared/components/ModernModal/components/ModalFooter/index.js